import { isReferencedValue, referencedNodeValue } from "../schemas/shared/valueConfig.ts";

/**
 * Collect every node id referenced by a dynamic value anywhere within a config
 * value — i.e. each node-value ReferencedValue, the authored design-time form.
 * (`__dv` references are the runtime form emitted only at publish; they
 * never appear in stored designer config, so we don't scan for them.) Manifest-free:
 * relies only on the well-known ReferencedValue shape, so it runs server-side too.
 */
export const extractNodeValueRefIds = (value: unknown): number[] => {
  const ids: number[] = [];

  const walk = (node: unknown) => {
    if (Array.isArray(node)) {
      for (const item of node) walk(item);
      return;
    }
    if (typeof node !== "object" || node === null) return;

    if (isReferencedValue(node)) {
      const nodeValue = referencedNodeValue(node);
      if (nodeValue) ids.push(nodeValue.nodeId);
      return; // a ReferencedValue's remaining fields are primitives — nothing nested to find
    }

    for (const child of Object.values(node)) walk(child);
  };

  walk(value);
  return ids;
};
